import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Form, Spinner } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'
import moment from 'moment'

import VehicleForm from './VehicleForm'

import { updateVehicle } from '../services'
import { handleError } from '../../../helpers'

export default function EditVehicleModal({ visible, onClose, vehicle, reload }) {
	const { handleSubmit, register, formState: { errors } } = useForm({ defaultValues: vehicle })
	const [loading, setLoading] = useState(false)

	const onSubmit = values => {
		setLoading(true)
		if(values.placas === vehicle.placas) delete values.placas
		values.register_at = moment(values.register_at).format('YYYY-MM-DD HH:mm')
		updateVehicle(vehicle.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<Modal isOpen={visible} toggle={onClose}>
			<ModalHeader toggle={onClose}>Actualizar Registro</ModalHeader>
			<ModalBody>
				<Form onSubmit={handleSubmit(onSubmit)}>
					<VehicleForm 
						register={register}
						errors={errors}
						editable
					/>
					<Button color='primary' type="submit" disabled={loading}>
						{ loading && <Spinner animation="border" size="sm" className='mr-1' /> }
						Actualizar Registro
					</Button>
				</Form>
			</ModalBody>
		</Modal>
	)
}